import React, { Component } from 'react';
import { urlApi } from '../Constants/Global';
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap';
import parse from 'html-react-parser';

export class SectionProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalTitle: '',
      modalImage: '',
      modalMessage: '',
      modalShow: false,
      modalGallery: ''
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleClose() {
    this.setState({ modalShow: false });
  }

  handleShow() {
    this.setState({ modalShow: true });
  }

  viewMore(v_item) {
    console.log(v_item);
    this.setState({
      modalTitle: v_item.set1,
      modalMessage: v_item.set2,
      modalGallery: v_item.set3
    });
    this.handleShow();
  }

  render() {
    return (
      <>
        <section className='section' id="product">
          <Container className="pt-5 pb-5">
            <h2 className="font-header mb-4">PRODUCTS</h2>
            <Row>
              {this.props.contents.map((item, index) => (
                <Col xs={12} md={6} key={index} onClick={() => this.viewMore(item)}>
                  <Card className="rounded-0 border-0 mb-3">
                    <div className="bg-img ratio-16x9" style={{ backgroundImage: 'url(' + urlApi + '/storage/media/' + item.set2 + ')' }}></div>
                    <Card.Text className='fs-4 p-2'>{item.set1}</Card.Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Modal show={this.state.modalShow} onHide={this.handleClose} fullscreen={true}>
          <Modal.Header closeButton>
            <Modal.Title className="itx-primary text-center w-100">{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="itx-dark p-5" scrollable={true}>
            <Container>
              <Row className="mb-3 fs-5">
                <Col sm={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} className="tx-service-modal">
                  {this.state.modalMessage ? <img src={urlApi + '/storage/media/' + this.state.modalMessage} className="w-100" alt="product" /> : ''}
                </Col>
              </Row>
              <Row className="mb-5">
                <Col sm={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} className="text-center">
                  <div className="ict-img-100">
                    {this.state.modalGallery ? parse(this.state.modalGallery) : ''}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button className="btn btn-sm ibt-primary px-3" onClick={this.handleClose}>กลับสู่หน้าหลัก</Button>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

SectionProduct.defaultProps = {
  contents: []
}

export default SectionProduct